import {
  GET_INTERNAL_ACCOUNT_LIST,
  GET_INTERNAL_ACCOUNT_LIST_SUCCESS,
  GET_INTERNAL_ACCOUNT_LIST_FAILED,
  CREATE_INTERNAL_ACCOUNT,
  CREATE_INTERNAL_ACCOUNT_SUCCESS,
  CREATE_INTERNAL_ACCOUNT_FAILED,
  UPDATE_INTERNAL_ACCOUNT,
  UPDATE_INTERNAL_ACCOUNT_SUCCESS,
  UPDATE_INTERNAL_ACCOUNT_FAILED,
  GET_INTERNAL_ACCOUNT_DETAIL,
  GET_INTERNAL_ACCOUNT_DETAIL_SUCCESS,
  GET_INTERNAL_ACCOUNT_DETAIL_FAILED,
  RESET_INTERNAL_ACCOUNT_DETAIL,
  DELETE_INTERNAL_ACCOUNT,
  DELETE_INTERNAL_ACCOUNT_SUCCESS,
  DELETE_INTERNAL_ACCOUNT_FAILED,
} from './actionTypes';

export const actionGetInternalAccountList = (payload) => ({
  payload,
  type: GET_INTERNAL_ACCOUNT_LIST,
});

export const actionGetInternalAccountListSuccess = (payload) => ({
  payload,
  type: GET_INTERNAL_ACCOUNT_LIST_SUCCESS,
});

export const actionGetInternalAccountListFailed = (payload) => ({
  payload,
  type: GET_INTERNAL_ACCOUNT_LIST_FAILED,
});

export const actionCreateInternalAccount = (payload) => ({
  payload,
  type: CREATE_INTERNAL_ACCOUNT,
});

export const actionCreateInternalAccountSuccess = (payload) => ({
  payload,
  type: CREATE_INTERNAL_ACCOUNT_SUCCESS,
});

export const actionCreateInternalAccountFailed = (payload) => ({
  payload,
  type: CREATE_INTERNAL_ACCOUNT_FAILED,
});

export const actionUpdateInternalAccount = (payload) => ({
  payload,
  type: UPDATE_INTERNAL_ACCOUNT,
});

export const actionUpdateInternalAccountSuccess = (payload) => ({
  payload,
  type: UPDATE_INTERNAL_ACCOUNT_SUCCESS,
});

export const actionUpdateInternalAccountFailed = (payload) => ({
  payload,
  type: UPDATE_INTERNAL_ACCOUNT_FAILED,
});

export const actionGetInternalAccountDetail = (payload) => ({
  payload,
  type: GET_INTERNAL_ACCOUNT_DETAIL,
});

export const actionGetInternalAccountDetailSuccess = (payload) => ({
  payload,
  type: GET_INTERNAL_ACCOUNT_DETAIL_SUCCESS,
});

export const actionGetInternalAccountDetailFailed = (payload) => ({
  payload,
  type: GET_INTERNAL_ACCOUNT_DETAIL_FAILED,
});

export const actionResetInternalAccountDetail = () => ({
  type: RESET_INTERNAL_ACCOUNT_DETAIL,
});

export const actionDeleteInternalAccount = (payload) => ({
  payload,
  type: DELETE_INTERNAL_ACCOUNT,
});

export const actionDeleteInternalAccountSuccess = (payload) => ({
  payload,
  type: DELETE_INTERNAL_ACCOUNT_SUCCESS,
});

export const actionDeleteInternalAccountFailed = (payload) => ({
  payload,
  type: DELETE_INTERNAL_ACCOUNT_FAILED,
});
